export default defineNuxtRouteMiddleware(async (to) => {
	if (process.server || ["/login", "/signup", "/verify-email", "/forgot-password", "/reset-password", "/account/settings/credentials"].includes(to.path)) return
	const { data, status, getSession } = useAuth()
	if (status.value === "loading") await getSession?.()
	if (data.value?.must_change_password) return navigateTo("/account/settings/credentials")
})
